import { useEffect, useState, useCallback } from 'react';

interface UseCountdownOptions {
  duration?: number;
  onComplete?: () => void;
}

interface UseCountdownReturn {
  countdown: number;
  isActive: boolean;
  start: () => void;
  reset: () => void;
}

export const useCountdown = ({
  duration = 60,
  onComplete,
}: UseCountdownOptions = {}): UseCountdownReturn => {
  const [countdown, setCountdown] = useState(duration);
  const [isActive, setIsActive] = useState(false);

  const start = useCallback(() => {
    setCountdown(duration);
    setIsActive(true);
  }, [duration]);

  const reset = useCallback(() => {
    setCountdown(duration);
    setIsActive(false);
  }, [duration]);

  useEffect(() => {
    if (!isActive || countdown <= 0) {
      if (isActive && countdown === 0) {
        setIsActive(false);
        onComplete?.();
      }
      return;
    }

    const interval = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive, countdown, onComplete]);

  return { countdown, isActive, start, reset };
};
